import React, {useState, useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import axiosInstance from '../../http/axios';

import Toast from '../../toast';
import Header from '../header/Header';

import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"

import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRounded from '@mui/icons-material/ArrowForwardRounded';
import AddRounded from '@mui/icons-material/AddRounded';
import { TextField, Button, Fab, IconButton, Input } from '@mui/material';
import DropdownMenu from '../dropdown_menu/DropdownMenu';
import {Pagination} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const BarberFormFullPage = () => {

     const location = useLocation();
     const naviagte = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

     const id = new URLSearchParams(location.search).get("id");

     const [data, setData] = useState({
          status: "",
          barberAddress: "",
          barberAdharcardImage1:"",
          barberAdharcardImage2: "",
          barberMobileNumber: "",
          barberPanImage1: "",
          barberStateName: "",
          barberUserName: "",

          areaDetails: "",
          cityName: "", 
          loginId: "",
          panNumber: "",
          pincodes: '',
          stateName: "",
          services: "",
          date: ""
     });
     const [open, setOpen] = React.useState(false);
     const [errorMessage, setErrorMessage] = useState(null);
     const [isSending, setIsSending] = useState(null);
     const tableHead = ["Category", "Subject", "Last message from", "Last message", "Date", ""];

     const fetch = async () => {
          try {
               const params = new URLSearchParams();
               params.append("id", id);

               const res = await axiosInstance.get('admin/host-form', {
                    params: params
               });
               setData({...res.data});
          } 
          catch (error) {
               setErrorMessage("Failed");
               console.log(error);
          }
     }

     const submit = async (status) => {
          try {
               const body = new FormData();
               body.append("id", id);
               body.append("status", status);
               body.append("rejectionMessage", data.rejectionMessage);
               body.append("services", data.services);
               body.append("pincodes", data.pincodes);

               const res = await axiosInstance.patch('admin/host-form', body, {
                    headers: { "Content-Type": "multipart/form-data" }
               });
               Toast.success("Submit");
               naviagte(-1);
          } 
          catch (error) {
               setErrorMessage("Failed");
               console.log(error);
               setIsSending(false);
          }
     }

     useEffect(async ()=>{
          fetch();
     }, []);

     const handleClickOpen = () => {
          setOpen(true);
        };
      
        const handleClose = () => {
          setOpen(false);
        };

     return (
          <>
               <Header/>
               <div className="container d-flex justify-content-around">
                    <div className='subject-box d-flex flex-column' style={{width: '50%', height: "auto"}}>
                         <header className='m-header'>
                              <IconButton onClick={()=>naviagte(-1)} style={{marginRight: '10px'}}><ArrowBackRounded/></IconButton>
                              <h1>Barber form</h1>
                              <span style={{flex: 1}}></span>
                         </header>
                         <div style={{display: 'flex', margin: '10px 30px'}}>
                              <h6 style={{display: 'inline'}}>Login ID</h6>
                              <span style={{flex: 1}}></span>
                              {data.loginId}
                         </div>
                         <div style={{display: 'flex', margin: '10px 30px'}}>
                              <h6 style={{display: 'inline'}}>Full Name</h6>
                              <span style={{flex: 1}}></span>
                              {data.barberUserName}
                         </div>
                         <div style={{display: 'flex', margin: '10px 30px'}}>
                              <h6 style={{display: 'inline'}}>State</h6>
                              <span style={{flex: 1}}></span>
                              {data.barberStateName}
                         </div>
                         <div style={{display: 'flex', margin: '10px 30px'}}>
                              <h6 style={{display: 'inline'}}>Mobile Number</h6>
                              <span style={{flex: 1}}></span>
                              {data.barberMobileNumber}
                         </div>
                         <div style={{display: 'flex', margin: '10px 30px'}}>
                              <h6 style={{display: 'inline'}}>Address</h6>
                              <span style={{flex: 1}}></span>
                              {data.barberAddress}
                         </div>
                         <div style={{display: 'flex', margin: '10px 30px'}}>
                              <h6 style={{display: 'inline'}}>PAN Number</h6>
                              <span style={{flex: 1}}></span>
                              {data.panNumber}
                         </div>
                         <div style={{margin: '10px 30px'}}>
                              <h6>Adharcard</h6>
                              <div className='d-flex justify-content-around' style={{maxHeight: '300px'}}>
                                   <img style={{width: '49%'}} src={data.barberAdharcardImage1}/>
                                   <img style={{width: '49%'}} src={data.barberAdharcardImage2}/>
                              </div>
                         </div>
                         <div style={{margin: '10px 30px'}}>
                              <h6>PAN Card</h6>
                              <div className='d-flex justify-content-around' style={{maxHeight: '300px'}}>
                                   <img style={{width: '49%'}} src={data.barberPanImage1}/>
                              </div>
                         </div>


                         <h4 style={{margin: '10px 30px'}}>Services Details</h4>
                         <div style={{display: 'flex', margin: '10px 30px'}}>
                              <h6 style={{display: 'inline'}}>State</h6>
                              <span style={{flex: 1}}></span>
                              {data.stateName}
                         </div>
                         <div style={{display: 'flex', margin: '10px 30px'}}>
                              <h6 style={{display: 'inline'}}>Area Details</h6>
                              <span style={{flex: 1}}></span>
                              {data.areaDetails}
                         </div>
                         <div style={{display: 'flex', margin: '10px 30px'}}>
                              <h6 style={{display: 'inline'}}>City</h6>
                              <span style={{flex: 1}}></span>
                              {data.cityName}
                         </div>
                         <div style={{display: 'flex', margin: '10px 30px'}}>
                              <h6 style={{display: 'inline'}}>Pincode</h6>
                              <span style={{flex: 1}}></span>
                              { data.status != "under_review" ? data.pincodes : 
                                   <Input type="text" multiline value={data.pincodes} onChange={(e)=>setData({...data, pincodes: e.target.value})} style={{width: '50%'}}/>
                              }
                         </div>
                         <div style={{display: 'flex', margin: '10px 30px'}}>
                              <h6 style={{display: 'inline'}}>Services</h6>
                              <span style={{flex: 1}}></span>
                              {data.services}
                              {/* {data.services.trim().split(",").map(v => v.trim()).filter(v => v !== "").map(val => <span className="p-2 m-1 rounded border text-center" style={{background: '#f2f2f2', }}>{val}</span>)} */}
                         </div>
                        
                         <span style={{flex: 1}}></span>
                         <div className='d-flex justify-content-around flex-column'>
                              {/* <button className='chat-actions' style={{margin: '10px 20px 10px 20px', width: '93%'}} onClick={()=> naviagte(`/admin-user-profile?id=${data.userId}&userName=${data.fullName}`)}>View user profile</button> */}
                              {data.status == "under_review" ? <div className='d-flex justify-content-around'>
                                   <button className='chat-actions' style={{margin: '0 10px 10px 20px', backgroundColor: 'red' }} onClick={()=>submit('rejected')} >Reject</button>
                                   <button className='chat-actions' style={{margin: '0 20px 10px 0', backgroundColor: 'green'}} onClick={()=> submit('active')} >Aprove</button>
                              </div> : null}
                         </div>
                    </div>
               </div>
               <Dialog open={open}>
                    <DialogTitle>Reject</DialogTitle>
                    <DialogContent>
                         <DialogContentText> Please write why you want to reject this form </DialogContentText>
                         <TextField
                              autoFocus
                              margin="dense"
                              id="name"
                              label=" Rejection message"
                              type="message"
                              fullWidth
                              variant="standard"
                              multiline 
                              value={data.rejectionMessage}
                              onChange={(e)=>setData({...data, rejectionMessage: e.target.value})}
                              />
                    </DialogContent>
                    <DialogActions>
                         <Button>Cancel</Button>
                         <Button onClick={()=>submit('rejected')}>Reject</Button>
                    </DialogActions>
               </Dialog>
          </>
     );
}


export default BarberFormFullPage;